export var ExhibitionistWidgetType;
(function(ExhibitionistWidgetType) {
    ExhibitionistWidgetType["TALL"] = "tall";
    ExhibitionistWidgetType["STRIP"] = "strip";
})(ExhibitionistWidgetType || (ExhibitionistWidgetType = {}));
export var ExhibitionistViewMode;
(function(ExhibitionistViewMode) {
    ExhibitionistViewMode["TORPEDO"] = "torpedo";
    ExhibitionistViewMode["SLIDESHOW"] = "slideshow";
})(ExhibitionistViewMode || (ExhibitionistViewMode = {}));
export var ExhibitionistSlideFitMode;
(function(ExhibitionistSlideFitMode) {
    ExhibitionistSlideFitMode["FIT"] = "fit";
    ExhibitionistSlideFitMode["COVER"] = "cover";
})(ExhibitionistSlideFitMode || (ExhibitionistSlideFitMode = {}));
export var GallectionSourceType;
(function(GallectionSourceType) {
    GallectionSourceType["FEATURED_GALLERY"] = "featured_gallery";
    GallectionSourceType["NEWEST"] = "newest";
    GallectionSourceType["GALLERY"] = "gallery";
    GallectionSourceType["COLLECTION"] = "collection";
    GallectionSourceType["PRIVATE_COLLECTION"] = "private_collection";
    GallectionSourceType["ADOPTABLE_BOUGHT"] = "adoptable_bought";
    GallectionSourceType["ADOPTABLE_FOR_SALE"] = "adoptable_for_sale";
})(GallectionSourceType || (GallectionSourceType = {}));
export var GallectionSortOrder;
(function(GallectionSortOrder) {
    GallectionSortOrder["NEWEST"] = "newest";
    GallectionSortOrder["POPULAR"] = "popular";
})(GallectionSortOrder || (GallectionSortOrder = {}));

//# sourceMappingURL=types.js.map